var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shop-subcategory-area"},[(!_vm.edit)?_c('ButtonComponent',{attrs:{"icon":_vm.area ? ['fal', 'ruler-triangle'] : ['fas', 'exclamation-circle'],"label":_vm.label,"theme":_vm.area ? 'default' : 'error'},on:{"click":() => {
        _vm.edit = true
        _vm.$emit('track', 'Area')
      }}}):[_c('InputComponent',{attrs:{"align":"right","suffix":"m²"},model:{value:(_vm.area),callback:function ($$v) {_vm.area=_vm._n($$v)},expression:"area"}}),_c('ButtonComponent',{attrs:{"icon":['fal', 'check'],"theme":"primary"},on:{"click":_vm.submit}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }